<template>
  <div>
    <sgds-masthead />
    <xbase-header>
      <!-- Service Menu -->
      <template>
        <xbase-header-service slot="header-service" :serviceMenuData="headerServiceMenu" />
      </template>

      <!-- Header Logo -->
      <xbase-header-logo
        slot="header-logo"
        :path="`/aceas/assets/common/vendor/xbase/img/cea-logo.png`"
        urlRedirection="/aceas/"
      />

      <!-- Header Profile -->
      <template>
        <HeaderProfile slot="header-profile" @logout="emitLogout" />
      </template>
    </xbase-header>
  </div>
</template>

<script>
// Child components of header
import HeaderProfile from "./HeaderProfile.vue";
import fetchPermissionMixin from "../../../mixins/fetchPermissionMixin";
import baseService from "./../../../services/index";

// Utility functions
const mapState = window.Vuex.mapState;

export default {
  mixins: [fetchPermissionMixin],
  components: {
    HeaderProfile
  },
  computed: {
    ...mapState({
      // These computed properties to control visibility of some header functions
      // Its value can be computed based on router path, vuex state, etc.
      isServiceVisible: state => state.auth.signedIn,
      isProfileVisible: state => state.auth.signedIn,
      accessToken: state => state.auth.accessToken,
      apiConfig: state => state.config.configurationData,
      additionalProfileInfo: state =>
        state.header.userProfile.additionalProfileInfo,
      isHeaderExitVisible() {
        return false;
      }
    }),
    headerServiceMenu() {
      return this.$store.getters["menus/headers"];
    },
    headerOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
    }
  },
  beforeMount() {
    // This is where you usually make update to state, computed value etc.
  },
  watch: {
    $route(to, from) {
      if (from.name === "Survey") this.fetchIsRegisteredStatus();
    }
  },
  mounted() {
    if (
      this.$route.name !== "Login" &&
      this.$route.name !== "OidcCallback" &&
      this.accessToken &&
      this.$store.state.auth.signedIn
    ) {
      this.fetchIsRegisteredStatus();
    }
  },
  methods: {
    emitLogout(value) {
      this.$emit("logout", value);
    },
    fetchIsRegisteredStatus() {
      if (!process.env.NODE_ENV === "development") {
        this.$store.commit("setApplicationLoadingToTrue");
      }
      const endpoint = this.apiConfig.common_module.profileManagement
        .getProfileBySgid;

      baseService(
        endpoint,
        {},
        this.setIsRESRegisteredStatus,
        this.handleFailed,
        this.headerOptions
      );
    },
    setIsRESRegisteredStatus(response) {
      this.$store.commit("header/setAdditionalProfileInfo", response.data.data);
      const generalInfo = response.data.data.profileDetailDto.generalInfoJson;
      if (generalInfo.name)
        this.$store.commit("header/setUserName", generalInfo.name);
      this.fetchPermission();
    },
    handleFailed(e) {
      this.fetchPermission();
      return e.message;
      // retriger changes //
    }
  },
  beforeDestroy() {
    this.$store.commit("rules/destroyRules");
  }
};
</script>
